import { Credentials, DemoRole, EnvironmentMode } from '@src/molecules/DemoForm/types';

export const DEMO_CREDENTIALS: Record<EnvironmentMode, Record<DemoRole, Credentials>> = {
  dev: {
    GMR: {
      email: 'testingcentra+gmr+demo@yandex.ru',
      password: 'QWEqwe123',
    },
    GMA: {
      email: 'testingcentra+gma+demo@yandex.ru',
      password: 'QWEqwe123',
    },
  },
  stage: {
    GMR: {
      email: 'testingcentra+gmr+demo@yandex.ru',
      password: 'QWEqwe123',
    },
    GMA: {
      email: 'testingcentra+gma+demo@yandex.ru',
      password: 'QWEqwe123',
    },
  },
  prod: {
    GMR: {
      email: 'demo_clients@centra.ai',
      password: 'TestP@ss987',
    },
    GMA: {
      email: 'demo_agency@centra.ai',
      password: 'TestP@ss987',
    },
  },
};

export const ERROR_REASON_NOTIFICATIONS = {
  CREDENTIALS_ERROR: {
    title: 'Неверный логин или пароль',
    text: 'Убедитесь в правильности написания электронной почты или пароля',
  },
  ACCOUNT_IS_BLOCKED: {
    title: 'Ваш аккаунт заблокирован',
    text: 'Чтобы продолжить работу, свяжитесь с Главным Менеджером или Аккаунт Менеджером',
  },
  DEFAULT_ERROR: {
    title: 'Возникла ошибка.',
    text: 'Пожалуйста, сообщите об ошибке вашему аккаунт-менеджеру в задаче или напишите нам на <a class="link" href="mailto:notify@centra.ai">notify@centra.ai</a>',
  },
};
